<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <dialog-table-page ref="subscribes" :pageData="subscribes"></dialog-table-page>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/merchandiser/util/url'
import dialogTablePage from '@/components/page/dialogTable.vue'

let userType = { 1: '代理', 2: '標準', 3: '行家', 4: '大師', 5: '傳奇' }

export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    dialogTablePage
  },
  mounted() {

  },
  methods: {
    bthClick(clickName, row) {
      if (clickName == 'subscribeList') {
        this.subscribeList(row)
      }
    },
    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      }
    },
    subscribeList(row) {
      this.subscribes.sync = true
      let data = { 'signalDealId': row.signalDealId }
      console.info(data)
      this.$refs.subscribes.defaultQueryData(data)
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }
  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '账号', field: 'customerNumber' },
          { title: '交易产品', field: 'symbol' },
          { title: 'dataType', field: 'dataType', data: 1, hidden: true },
          { title: '订单号', field: 'orderId' },
          { title: '成交號', field: 'dealId' },
          { title: '執行開始時間', field: 'startTime', type: 5 },
          { title: '執行結束時間', field: 'endTime', type: 5 },
          { click: window.$t('common.search') }
        ]
      },
      subscribes: {
        queryUrl: Url.signal.openList, //请求路径和参数
        title: '跟隨人員開倉記錄',
        sync: false,
        isShow: false,
        sequence: true,
        method: 'get',
        cols: [
          { title: '信號源DealId', field: 'signalDealId' },
          { title: 'accountId', field: 'accountId' },
          { title: '交易账号', field: 'customerNumber' },
          { title: '公司', field: 'companyId' },
          { title: '交易平台', field: 'platform' },
          { title: '交易产品', field: 'symbol' },
          { title: '产品簡稱', field: 'symbolDisplayName' },
          { title: '方向', field: 'direct' },
          { title: '成交手数', field: 'volume' },
          { title: '开仓保证金', field: 'margin' },
          { title: '持倉號', field: 'positionId' },
          { title: '訂單ID', field: 'orderId' },
          { title: '成交ID', field: 'dealId' },
          { title: '开仓价格', field: 'price' },
          { title: '下單情況', field: 'comment' },
          { title: '下單狀態', field: 'ptsStatus' },
          {
            title: '生成時間', field: 'createTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '推送時間', field: 'sendToSocketTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '更新時間', field: 'updateTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '執行時間', field: 'exeTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '止盈', field: 'stopProfit' },
          { title: '止损', field: 'stopLoss' },
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.signal.openList,
        selection: false,
        sequence: true,
        size: 10,
        method: 'get',
        cols: [
          { title: '賬號ID', field: 'accountId' },
          { title: '交易账号', field: 'customerNumber' },
          { title: '公司', field: 'companyId' },
          { title: '交易平台', field: 'platform' },
          { title: '交易产品', field: 'symbol' },
          { title: '产品簡稱', field: 'symbolDisplayName' },
          { title: '方向', field: 'direct' },
          { title: '成交手数', field: 'volume' },
          { title: '开仓保证金', field: 'margin' },
          { title: '持倉號', field: 'positionId' },
          { title: '訂單ID', field: 'orderId' },
          { title: '成交ID', field: 'dealId' },
          { title: '开仓价格', field: 'price' },
          { title: '預計盈利', field: 'profit' },
          {
            title: '生成時間', field: 'createTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '止盈', field: 'stopProfit' },
          { title: '止损', field: 'stopLoss' },
          {
            title: '操作',
            btnClick: [
              {
                name: '跟單詳情',
                click: 'subscribeList',
                type: 'primary'
              }]
          }
        ]
      }
    }
  }
}
</script>
